import React, { Component } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';

const localizer = momentLocalizer(moment);

class EventCalendar extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
        this.sendToEventPage = this.sendToEventPage.bind(this);
    }

    componentDidMount() {
        // No need to load configuration from backend anymore
        // Colors are now stored in localStorage
    }

    sendToEventPage(event) {
        if (event.eventUrl != null) {
            return window.location = event.eventUrl;
        }
        else {
            this.props.populateCalendarFilter(event.start);
        }
    }

    eventStyleGetter = (event, start, end, isSelected) => {
        const style = {
            backgroundColor: event.color,
            borderRadius: '0px',
            opacity: 0.8,
            color: 'white',
            border: '0px',
            display: 'block'
        };
        return {
            style: style
        };
    }

    render() {
        let rawEvents = this.props.events;
        
        // Get color mapping from localStorage
        let typeColorMap = {};
        try {
            const saved = localStorage.getItem('eventTypeColors');
            if (saved) {
                typeColorMap = JSON.parse(saved);
            }
        } catch (e) {
            console.error('Error parsing saved type colors:', e);
        }

        // Fallback colors for types not in configuration
        let colorType = [
            "#FF0000", "#00FF00", "#0000FF", "#FFFF00", "#FF00FF", "#00FFFF", "#800000", "#808000", 
            "#008000", "#800080", "#008080", "#000080", "#FFA500", "#A52A2A", "#DC143C", "#00CED1",
            "#FF1493", "#4B0082", "#ADFF2F", "#FF6347", "#20B2AA", "#7CFC00", "#FF4500", "#DA70D6",
            "#40E0D0", "#1E90FF", "#9370DB", "#FFD700", "#B22222", "#2E8B57"
        ];
        
        const distinctTypes = [...new Set(rawEvents.map(event => event.types))];
        distinctTypes.forEach((type, index) => {
            if (!typeColorMap[type]) {
                typeColorMap[type] = colorType[index % colorType.length];
            }
        });
        
        let events = [];
        for (var i = 0; i < rawEvents.length; i++) {
            let event = rawEvents[i];

            let eventUrl = '/event/' + event.friendlyUrl;
            let eventTime = new Date(event.startTime);
            let endTime = new Date(event.endTime);

            // Skip events with invalid start dates
            if (isNaN(eventTime)) {
                continue;
            }

            // If end time is invalid or from year 0001 (default C# DateTime), set it to 1 hour after start time
            if (isNaN(endTime) || endTime.getFullYear() <= 1) {
                endTime = new Date(eventTime.getTime() + (60 * 60 * 1000)); // Add 1 hour
            }

            // Show all events (removed the daily limit of 2 events per day)
            let calEvent = {
                id: i,
                title: event.title,
                start: eventTime,
                end: endTime,
                eventUrl: eventUrl,
                color: typeColorMap[event.types] || "#808080" // Default gray if no type
            };
            events.push(calEvent);
        }


        return (
            <div className='event-calendar-container'>
                <div style={{ height: '500pt' }}>
                    <Calendar
                        events={events}
                        startAccessor="start"
                        endAccessor="end"
                        defaultDate={moment().toDate()} 
                        localizer={localizer}
                        views={['month']}
                        onSelectEvent={this.sendToEventPage}
                        eventPropGetter={this.eventStyleGetter}
                    />
                </div>
            </div>
        );
    }
}

export default EventCalendar;
